import { PlanType } from '../usePlans';

type GenerateUniqueIdType = {
  plan: PlanType;
  paywallLocation: string;
  customPrefix?: string | null;
};

export const generateUniqueId = ({ plan, paywallLocation, customPrefix = null }: GenerateUniqueIdType): string => {
  return `${customPrefix ?? plan?.billingCode}-${paywallLocation}${plan?.isUpgradePath ? '-upgrade' : ''}`;
};
